// extracted by css-extract-rspack-plugin
export default {"traceField":"bNsq3A7af3k0A0ow"};